// extracted by mini-css-extract-plugin
export default {"valueBarDetails":"value-bar_valueBarDetails__Mq3iQ","valueBarDetailsValue":"value-bar_valueBarDetailsValue__PRKwK","valueBarDetailsTotal":"value-bar_valueBarDetailsTotal__WkCeb"};